import moment from "moment";
import { Tooltip } from "@mui/material";
import React, { useContext, useState } from "react";
import NoRowOverlay from "views/pages/manage/academicPlanAndTest/searchAcademicPlan/NoRowOverlay";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { isActiveBusinessArea } from "views/pages/manage/unAssigned/collectPayment/utils.jsx";

import {
  blockedStatus,
  BUPopover,
  checkActionAccesibility,
  checkApprovalStatus,
  CourseTermPopover,
  getStatus,
  lastUpdatedByOn,
  RemarksPopover,
  statusMapping,
  statusStyle,
} from "./constant";
import { RolePermissions } from "appContext";
import { PermissionContext } from "appContext";
import { pages } from "views/pages/manage/common/constant";
import { formattedPrice } from "../../collectPayment/utils";
import { epmrStatusChipInfo } from "../../../masters/studentFinancials/paymentCollection/EPMR/constants";
import { getEpmrStatus } from "../../../masters/studentFinancials/paymentCollection/EPMR/EpmrReceiptsListing";
import CustomChip from "../../../common/customChip/CustomChip";

const getUpdatedStatusForRemark = status => {
  if(status?.includes('REJECT')) return status;
  return "PENDING"; //we need to show submitter remark in all cases other than reject case
}

const ListComponent = ({
  paginationData,
  loading,
  rows,
  actionHandler,
  pageHandler,
  businessAreaDropdown,
}) => {
  const userPermissions =
    RolePermissions(
      useContext(PermissionContext),
      pages["epmrCancellation"]["id"]
    ) || [];
  const [courseMap, setCourseMap] = useState({});
  const [remarksMap, setRemarksMap] = useState({});
  const [buDescriptionMap, setBuDescriptionMap] = useState({});
  const columns = [
    new AGridColDef("epmrNumber", "EPMR No.", false)
      .setMinWidth(140)
      .editable(false)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("businessAreaValue", "Branch Code", false)
      .setMinWidth(110)
      .editable(false)
      .setFlex(0.5)
      .renderCellComponent((params) => (
        <div>
          <span>{params.value}</span>&nbsp;
          <span>
            <BUPopover
              businessArea={params.value}
              businessAreaOptions={businessAreaDropdown}
              buDescriptionMap={buDescriptionMap}
              setBuDescriptionMap={setBuDescriptionMap}
            />
          </span>
        </div>
      )),
    new AGridColDef("psid", "PSID", false)
      .setMinWidth(140)
      .editable(false)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("studentName", "Student name", false)
      .setMinWidth(110)
      .editable(false)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("courseId", "Course ID", false)
      .setMinWidth(80)
      .editable(false)
      .setFlex(0.4)
      .renderCellComponent((params) =>
        params?.value ? (
          <>
            {" "}
            <div>
              <span>{params.value}</span>&nbsp;
              <span>
                <CourseTermPopover
                  courseId={params?.value}
                  term={params?.row.termValue}
                  courseTermMap={courseMap}
                  setCourseTermMap={setCourseMap}
                />
              </span>
            </div>
          </>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("totatAmountReceived", "Total Amount Received", false)
      .setMinWidth(110)
      .editable(false)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>
              {formattedPrice(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("paymentMode", "Payment mode", false)
      .setMinWidth(110)
      .editable(false)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("remark", "Remarks", false)
      .setMinWidth(80)
      .editable(false)
      .setFlex(0.4)
      .renderCellComponent((params) =>
        // ["Rejected", "Pending"].includes(
        //   statusMapping[(params?.row?.status).toUpperCase()]
        // ) ? (
          <RemarksPopover
            epmrNumber={params?.row?.epmrNumber}
            status={getUpdatedStatusForRemark(params?.row.status)}
            remarksMap={remarksMap}
            setRemarksMap={setRemarksMap}
          />
        // ) : (
        //   "-"
        // )
      ),

    new AGridColDef("epmrStatus", "EPMR Status", false)
      .setMinWidth(120)
      .renderCellComponent((params) =>
        <CustomChip style={{ fontSize: '12px' }} {...epmrStatusChipInfo[getEpmrStatus(params?.row)]} />
      ),

    new AGridColDef("receiptDate", "EPMR Date", false)
      .setMinWidth(110)
      .editable(false)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip
            title={
              params?.value
                ? moment(params?.value).format("DD-MM-YY")
                : params?.value
            }
          >
            <div className={`ellipsis-text-container`}>
              {params?.value
                ? moment(params?.value).format("DD-MM-YY")
                : params?.value}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    new AGridColDef("updatedOn", "Last Updated On/By")
      .setMinWidth(170)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={lastUpdatedByOn(params?.value, params.row.updatedBy)}>
            <div className="ellipsis-text-container">
              {lastUpdatedByOn(params?.value, params.row.updatedBy)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),
    new AGridColDef("status", "Status", false)
      .setMinWidth(110)
      .editable(false)
      .setFlex(0.5)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip
            title={
              statusMapping?.[
                checkApprovalStatus(
                  (params?.value).toUpperCase(),
                  params?.row?.isApproved
                )
              ] ?? params?.value
            }
          >
            <div
              className={`ellipsis-text-container`}
              style={
                statusStyle?.[
                  statusMapping?.[
                    checkApprovalStatus(
                      (params?.value).toUpperCase(),
                      params?.row?.isApproved
                    )
                  ]
                ]
              }
            >
              {getStatus(params?.value, params?.row?.isApproved) ??
                params?.value}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),
    ...(userPermissions?.includes("C") || userPermissions?.includes("U")
      ? [
          new AGridColDef("actions", "Action", false)
            .setMinWidth(200)
            .setFlex(0.8)
            .editable(false)
            .pinColumnLast(true)
            .renderCellComponent(
              (params) =>
                isActiveBusinessArea({
                  buLabel: params.row.businessAreaValue,
                }) &&
                checkActionAccesibility(params?.row) &&
                (getStatus(params?.row?.status, params?.row?.isApproved) !=
                "Approved" ? (
                  <>
                    <AButton
                      variant="outline_danger"
                      size="xs"
                      className="no-ml-btn"
                      onClick={() => {
                        actionHandler(params?.row, "reject");
                      }}
                      disabled={blockedStatus.includes(
                        checkApprovalStatus(
                          (params?.row?.status).toUpperCase(),
                          params?.row?.isApproved
                        )
                      )}
                    >
                      Reject
                    </AButton>

                    <AButton
                      variant="primary_filled"
                      size="xs"
                      onClick={() => {
                        actionHandler(params?.row, "approve");
                      }}
                      disabled={blockedStatus.includes(
                        checkApprovalStatus(
                          (params?.row?.status).toUpperCase(),
                          params?.row?.isApproved
                        )
                      )}
                      //disabled={params?.row?.status=='PENDING'}
                    >
                      Approve
                    </AButton>
                  </>
                ) : (
                  <></>
                ))
            ),
        ]
      : []),
  ];
  return (
    //{(loading || !allActiveBu?.length) && <ALoader position='fixed' />}
    <ADataGrid
      removeWrapperContainer
      // rowModesModel={rowModesModel}
      rows={rows || []}
      columns={columns}
      rowId={(row) => row.id}
      rowHeight={50}
      loading={false}
      rowCount={paginationData?.totalRecords}
      nextButtonHandler={(page) => {
        pageHandler(page);
      }}
      currentPage={paginationData?.currentPage}
      components={{
        ...gridComponents,
        NoRowsOverlay: () => (
          <NoRowOverlay message={loading ? "Loading..." : null} />
        ),
      }}
      sx={gridStyles}
      autoHeight
      pinLastColumn
    />
  );
};

export default ListComponent;
